import { removeUser } from "../../../../store/slices/userSlice";
import {
  setActiveVk,
  setDataVk,
  setIsConnectedVk,
  setIsErrorVk,
  setIsLoadingVk,
  setUpdateVk,
} from "../../../../store/slices/vkSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

// Инит вк
export const initVk = (dataVk, setError) => {
  return async (dispatch) => {
    dispatch(setIsLoadingVk(true));

    try {
      const { data } = await $authHost.post(
        `/integrations/vk/initialization`,
        dataVk
      );

      if (data.code === 200) {
        dispatch(setIsLoadingVk(false));
        dispatch(setIsConnectedVk(true));
        dispatch(getVkIntegrations(dataVk.userId));
      } else {
        setError(data.message || "Ошибка при инициализации ВК.");
        errorToast(data.message || "Ошибка при инициализации ВК.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          setError("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        setError("Проблемы с подключением. Проверьте интернет.");
      } else {
        setError("Произошла неизвестная ошибка.");
      }

      console.error("Error initVk:", error);
    } finally {
      dispatch(setIsLoadingVk(false));
    }
  };
};

// Получение списка интгераций
export const getVkIntegrations = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/vk/list?userId=${userId}`
      );

      if (data.code === 200) {
        dispatch(setDataVk(data.groups));
      } else {
        errorToast(data.message || "Ошибка при получении интеграций ВК.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.error("Ошибка при получении интеграций ВК:", error);
    }
  };
};

// Получение данных о конкретной интеграции
export const getVkIntegration = (userId, groupId, setLoading = () => {}) => {
  return async (dispatch) => {
    dispatch(setIsErrorVk(false));
    setLoading(true);
    try {
      const { data } = await $authHost.get(
        `/integrations/vk?userId=${userId}&groupId=${groupId}`
      );

      if (data.code === 200) {
        localStorage.setItem("dataVk", JSON.stringify(data.group));
        dispatch(setActiveVk(data.group));
      } else {
        errorToast(data.message || "Ошибка при получении интеграции ВК.");
      }
    } catch (error) {
      dispatch(setIsErrorVk(true));
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.error("Ошибка при получении интеграции ВК:", error);
    } finally {
      setLoading(false);
    }
  };
};

// Редактирование интеграции
export const configureVkClient = (configuration) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/vk/client`,
        configuration
      );

      if (data.code === 200) {
        dispatch(getVkIntegration(configuration.userId, configuration.groupId));
        dispatch(setUpdateVk(false));
      } else {
        errorToast(data.message || "Ошибка при конфигурации ВК-клиента.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.error("Ошибка configureVkClient:", error);
    }
  };
};

// Деактивация вк
export const deactivateVk = (dataDeactivation, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/vk/deactivation`,
        dataDeactivation
      );

      if (data.code === 200) {
        setLoading(false);
        dispatch(setIsConnectedVk(false));
        dispatch(setActiveVk(null));
        navigate("/integration");
        dispatch(getVkIntegrations(dataDeactivation.userId));
      } else {
        errorToast(data.message || "Ошибка деактивации ВК.");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.error("Ошибка deactivateVk:", error);
    }
  };
};
